import { render, staticRenderFns } from "./request-aoi-list-item.vue?vue&type=template&id=bf48f824&scoped=true&"
import script from "./request-aoi-list-item.vue?vue&type=script&lang=js&"
export * from "./request-aoi-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf48f824",
  null
  
)

export default component.exports